import React, { useEffect, useState } from 'react'
import Navbar from '../Navbar';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import Cookies from 'js-cookie';
import Menu_Items from '../Menu_Items';
import { RiFileShield2Fill } from "react-icons/ri";

function In_Log_files() {
  const { id, int_id, value } = useParams();

  const [su_admin, setsu_admin] = useState(false)
  const [admin, setadmin] = useState(false)
  const [log_details, setlog_details] = useState([]);


  const menus = [
    {
      name: 'Integrations',
      id
    },
    {
      name: 'Out Bound',
      id,
      submenu: [{ name: 'All Out Bounds', id, int_id, type: 'Out' }
      ]
    },
    (su_admin || admin ? { name: 'Users', id } : { name: null, id })
  ];
  const get_files = async () => {
    await axios.get(`/out_bound/log/${value}`).then((res) => {
      setlog_details(res.data);
    })
      .catch((err) => {
        console.log('error');
      });
  };
  const get_level = () => {
    const level = Cookies.get("level");
    if (level === "Super Admin") {
      setsu_admin(true);
    }
    else if (level === 'Admin') {
      setadmin(true)
    }
  };

  useEffect(() => {
    get_files();
    get_level();
  }, []);
  return (
    <div className='container df fdc ac'>
      <Navbar />
      <div className='main_box df'>
        <Menu_Items menu={menus} />
        <div className='content df fdc ac'>
          <div className='page_header df jb ac'>
            <div className='w90 df ac'>
              <RiFileShield2Fill className='page_icon db' />
              <p>Log Files</p></div>
          </div>
          <table className='df fdc ac'>
            <thead>
              <tr className='df js ac'>
                <th>S.No</th>
                <th>Type</th>
                <th>File Name</th>
                <th>Date</th>
                <th>Time</th>
              </tr>
            </thead>
            <tbody>
              {
                log_details.length === 0 && <div className='no_Records h50 w100  df jc ac'>
                  <p>No Records</p>
                </div>
              }
              {
                log_details.length > 0 && log_details.map((obj, index) => {
                  return (
                    <tr className='df jc ac' key={index}>
                      <td className='df js ac'>{index + 1}</td>
                      <td className='df js ac'>{obj.type}</td>
                      <td className='df js ac'>{obj.file_name}</td>
                      <td className='df js ac'>{obj.date}</td>
                      <td className='df js ac'>{obj.time}</td>
                    </tr>
                  )
                })
              }
            </tbody>
          </table>
        </div>
      </div>
      {/* <div className='h_btn df jc ae'>
        <p className='df jc ac'>Log Files</p>
        <div className='menu_bar h5 w25 df je ac gap1'>
          <Link to={home_path} className='menu_icon df jc ac' ><AiFillHome className='icon2' /></Link>
          {
            (admin_level) &&
            <Link to={`/company/users/${id}`} className='menu_icon df jc ac'><FaUsers className='icon2' /></Link>
          }
          {
            (admin_level || user_level || monitor_level) &&
            <>
              <Link to={`/integ/${id}`} className='menu_icon df jc ac'><SiGitconnected className='icon2' /></Link>
              <Link to={`/out_bound_details/${id}/${int_id}`} className='menu_icon df jc ac' ><RiExportFill className='icon2' /></Link>
            </>
          }
          <Link to={"/"} className='menu_icon df jc ac' ><MdLogout className='icon2' /></Link>
        </div>
      </div> */}


      {/* <Back location={`/out_bound_details/${id}/${int_id}`} /> */}
    </div >
  )
}

export default In_Log_files;